import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ChipSearchResult } from '@barkinglabs/nano-shared';
import PetDetails from '../../appview/components/ChipDetails/PetDetails/PetDetails';
import ResellerDetails from '../../appview/components/ChipDetails/ResellerDetails/ResellerDetails';
import ContactDetails from '../../appview/components/ChipDetails/ContactDetails/ContactDetails';
import SearchResultFooter from './SearchResultFooter';
import { AppState } from '@/lib/store';

export interface SearchResultsProps {
  result: ChipSearchResult;
}

export default function SearchResult({ result }: SearchResultsProps) {
  const session = useSelector((state: AppState) => state.session);

  return (
    <div>
      {result.pet && <PetDetails pet={result.pet} chip={result.chip} searchResult={result} />}
      {result && !result.pet && <ContactDetails searchResult={result} />}
      {result.reseller && <ResellerDetails searchResult={result} reseller={result.reseller} />}
      {!session && (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Link to="/login">Rescues login here to see all chip details</Link>
        </div>
      )}
      <SearchResultFooter result={result} />
    </div>
  );
}
